import { ApolloLink, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { RetryLink } from "@apollo/client/link/retry";
import { createUploadLink } from "apollo-upload-client";
// import { getFirebaseIdToken } from "../../firebase";

const quizLink = createUploadLink({
  uri: `${process.env.REACT_APP_QUIZ_API_URL}/graphql`,
});

const omniLink = createUploadLink({
  uri: `${process.env.REACT_APP_OMNI_API_URL}/graphql`,
});

const uploadLink = createUploadLink({
  uri: `${process.env.REACT_APP_API_URL}/graphql`,
});

const infohubLink = createUploadLink({
  uri: `${process.env.REACT_APP_INFOHUB_API_URL}/graphql`,
});

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) =>
      console.log(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      )
    );
  } else if (networkError) {
    console.log(`[Network error]: ${networkError}`);
  }
});

const tokenLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((response) => {
    const context = operation.getContext();
    const authHeader = context.response.headers.get("Authorization");

    if (authHeader) {
      localStorage.setItem("authToken", authHeader.split("Bearer ")[1]);
    }

    return response;
  });
});

const retryLink = new RetryLink({
  delay: {
    initial: 300,
    max: Infinity,
    jitter: true,
  },
  attempts: {
    max: 3,
    retryIf: (error) => !!error,
  },
});

const authLink = setContext(async (_, { headers }) => {
  try {
    const token = localStorage.getItem("authToken");
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : undefined,
        "apollo-require-preflight": "true",
      },
    };
  } catch (err) {
    console.error(err);
  }
});

const routeLink = new ApolloLink((operation, forward) => {
  const name = operation.operationName || "";

  if (name.includes("Omni")) {
    return omniLink.request(operation, forward)!;
  }

  if (name.includes("AdminQuiz")) {
    return quizLink.request(operation, forward)!;
  }

  if (name.includes("Infohub")) {
    return infohubLink.request(operation, forward)!;
  }

  return uploadLink.request(operation, forward)!;
});

export default from([retryLink, errorLink, tokenLink, authLink, routeLink]);
